import axios from 'axios';

// Clinic API base URL - uses /api/clinic prefix
const clinicApi = axios.create({
  baseURL: 'https://clinic.vintierpsolution.cloud/backend/api/clinic',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request interceptor to add token and tenant ID
clinicApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('clinic_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // ALWAYS send tenant ID from stored user data
    const user = localStorage.getItem('clinic_user');
    console.log('Raw user from localStorage:', user);
    if (user) {
      try {
        const userData = JSON.parse(user);
        console.log('Parsed userData:', userData);
        console.log('userData.tenant_id:', userData.tenant_id);
        if (userData.tenant_id) {
          config.headers['X-Tenant-ID'] = userData.tenant_id;
          console.log('Set X-Tenant-ID header:', userData.tenant_id);
        } else {
          console.warn('No tenant_id found in userData');
        }
      } catch (e) {
        console.error('Error parsing clinic user:', e);
      }
    } else {
      console.warn('No clinic_user in localStorage');
    }
    
    console.log('Final request headers:', config.headers);
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
clinicApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('clinic_token');
      localStorage.removeItem('clinic_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default clinicApi;
